/**
 * @description 保單寄送方式用
*/
export enum PolicyDelivery {
  /** 電子保單 */
  Electric = '1',
  /** 紙本保單 */
  Paper = '2'
}

/**
 * @description 對應保單寄送方式名稱用
*/
export enum PolicyDeliveryName {
  /** 電子保單 */
  Electric = '電子保單',
  /** 紙本保單 */
  Paper = '紙本保單'
}

/**
 * @description 對應保單寄送方式名稱用
*/
export type DeliverByType = '1' | '2' | 'A';

export const DeliverBy = {
  /** 電子保單 */
  Electric: '1',
  /** 紙本保單 */
  Paper: '2',
  /** 電子保單 and 紙本保單 */
  ElectricAndPaper: 'A'
} as const;
